export const GET_PATIENT_DETAILS = 'GET_PATIENT_DETAILS'
export const SET_PATIENT_LOADING = 'SET_PATIENT_LOADING'
